interface UsageBreakdownRow {
    label: string;
    value: number;
    secondary?: string;
}

interface UsageBreakdownTableProps {
    title: string;
    rows: UsageBreakdownRow[];
}

export const UsageBreakdownTable = ({ title, rows }: UsageBreakdownTableProps) => {
    return (
        <div className="rounded-2xl border border-slate-200/70 dark:border-slate-700/60 bg-white dark:bg-slate-900 overflow-hidden">
            <div className="px-4 py-3 border-b border-slate-100 dark:border-slate-800">
                <h3 className="text-sm font-bold text-slate-700 dark:text-slate-200">{title}</h3>
            </div>
            <div className="divide-y divide-slate-100 dark:divide-slate-800">
                {rows.length === 0 ? (
                    <div className="px-4 py-6 text-sm text-slate-500">No data available</div>
                ) : rows.map((row) => (
                    <div key={`${row.label}-${row.secondary || ''}`} className="px-4 py-3 flex items-center justify-between gap-3">
                        <div>
                            <p className="text-sm font-semibold text-slate-700 dark:text-slate-200">{row.label}</p>
                            {row.secondary ? <p className="text-xs text-slate-500">{row.secondary}</p> : null}
                        </div>
                        <p className="text-sm font-mono font-bold text-slate-800 dark:text-slate-100">{row.value}</p>
                    </div>
                ))}
            </div>
        </div>
    );
};
